module.exports = __webpack_public_path__ + "img/sawmilllab.00d171ac.webp";